module.exports = __webpack_public_path__ + "static/media/support.dfcf6422.svg";